/**
 * @desc 待审核信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.ExportDeclarationDSHRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/dshExportDeclaration`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
